import * as React from 'react';
import { ApiSpaceDetails } from '../api/ApiTypes';

type SpaceDetailContextProps = {
    spaceDetails: ApiSpaceDetails;
    setSpaceDetails: React.Dispatch<ApiSpaceDetails>;
};

export const SpaceDetailContext = React.createContext({} as SpaceDetailContextProps);
